import { render, staticRenderFns } from "./incident-attachments.vue?vue&type=template&id=609b87ce&scoped=true"
import script from "./incident-attachments.vue?vue&type=script&lang=js"
export * from "./incident-attachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609b87ce",
  null
  
)

export default component.exports